import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import api from "../../lib/api";
import { Button } from "../ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ServicesPreview = () => {
  const { t, lang } = useLanguage();
  const [services, setServices] = useState(null);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => setServices([]));
  }, []);

  return (
    <section data-testid="services-preview-section" className="py-20 sm:py-28 px-4 sm:px-6 bg-[#080808]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-12 gap-4">
          <div>
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-white mb-3 tracking-tight">{t("services.title")}</h2>
            <p className="text-white/60 text-base max-w-md">{t("services.subtitle")}</p>
          </div>
          <Link to="/diensten">
            <Button data-testid="services-view-all-button" variant="outline" className="bg-transparent border border-white/20 text-white hover:border-gold hover:text-gold rounded-none px-6">
              {t("services.viewAll")}
            </Button>
          </Link>
        </div>

        {services === null && <p className="text-white/50">{t("common.loading")}</p>}

        {services && services.length === 0 && (
          <div data-testid="services-coming-soon" className="bg-[#141414] border border-white/5 rounded-xl p-10 text-center">
            <p className="text-gold text-lg mb-2">{t("services.comingSoonTitle")}</p>
            <p className="text-white/60">{t("services.comingSoonText")}</p>
          </div>
        )}

        {services && services.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.slice(0, 6).map((s) => (
              <div key={s.id} data-testid={`service-card-${s.id}`} className="bg-[#141414] border border-white/5 rounded-xl overflow-hidden flex flex-col justify-between hover:border-gold/40 transition-colors">
                {s.image_url && (
                  <img src={`${BACKEND_URL}${s.image_url}`} alt={lang === "nl" ? s.name_nl : s.name_en} className="w-full h-40 object-cover" />
                )}
                <div className="p-6 flex flex-col justify-between flex-1">
                <div>
                  <h3 className="text-white text-lg font-medium mb-2">{lang === "nl" ? s.name_nl : s.name_en}</h3>
                  {(lang === "nl" ? s.description_nl : s.description_en) && (
                    <p className="text-white/50 text-sm mb-4">{lang === "nl" ? s.description_nl : s.description_en}</p>
                  )}
                  <div className="flex items-center gap-2 text-white/40 text-sm mb-4">
                    <Clock size={14} /> {s.duration} {t("services.minutesLabel")}
                  </div>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-white/5">
                  <span className="text-gold text-xl font-serif">€{s.price % 1 === 0 ? s.price.toFixed(0) : s.price}</span>
                  <Link to={`/boeken?service=${s.id}`} data-testid={`service-book-${s.id}`} className="text-sm text-white/80 hover:text-gold underline underline-offset-4">
                    {t("services.bookThis")}
                  </Link>
                </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
